export default {
    language: '繁體中文',
    topNavigation: [
        {name: '新聞', active: '', path: '/news'},
        {name: '聯繫我們', active: '', path: '/contact'},
        {name: '站點地圖', active: '', path: '/site_map'}
    ],
    headNavigation: [
        {name: '產品', active: '', path: '/products'},
        {name: '技術', active: '', path: '/technology'},
        {name: '公司', active: '', path: '/company'},
        // {name:'紅外光譜信息',active: '',path: '/ir'}
    ],
    languages: [
        {code: 'zhCN', name: '簡體中文'},
        {code: 'en', name: 'English'}
    ],
    something: [
        {title: '產品', details: '介紹我們的產品信息', active: '', path: '/products'},
        {title: '技術', details: '處理案例介紹和技術數據', active: '', path: '/technology'},
        {title: '公司', details: '關於我們,訪問地圖和訪問政策', active: '', path: '/company'},
        // {title:'紅外光譜信息',details:'投資者信息及各種財務報表',active: '',path: '/ir'}
    ],
    routeMap: [
        {name: '首頁', path: '/'}
    ],
    series: [
        {name: '切削工具'},
        {name: '金刚石'},
        {name: '光学用品'},
        {name: '超硬材料'}
    ]
}